import logErr from './logger/error';



export const ITUNES_CATEGORY_MAP = {
  itunes_books: 'sm@_itunes_books',
  itunes_business: 'sm@_itunes_business',
  itunes_catalogs: 'sm@_itunes_catalogs',
  itunes_education: 'sm@_itunes_education',
  itunes_entertainment: 'sm@_itunes_entertainment',
  itunes_developer_tools: 'sm@_itunes_developer_tools',
  itunes_finance: 'sm@_itunes_finance',
  itunes_food_and_drink: 'sm@_itunes_food_and_drink',
  itunes_graphics_and_design: 'sm@_itunes_graphics_and_design',
  itunes_games: 'sm@_itunes_games',
  itunes_games_action: 'sm@_itunes_games_action',
  itunes_games_adventure: 'sm@_itunes_games_adventure',
  itunes_games_arcade: 'sm@_itunes_games_arcade',
  itunes_games_board: 'sm@_itunes_games_board',
  itunes_games_card: 'sm@_itunes_games_card',
  itunes_games_casino: 'sm@_itunes_games_casino',
  itunes_games_dice: 'sm@_itunes_games_dice',
  itunes_games_educational: 'sm@_itunes_games_educational',
  itunes_games_family: 'sm@_itunes_games_family',
  itunes_games_kids: 'sm@_itunes_games_kids',
  itunes_games_music: 'sm@_itunes_games_music',
  itunes_games_puzzle: 'sm@_itunes_games_puzzle',
  itunes_games_racing: 'sm@_itunes_games_racing',
  itunes_games_role_playing: 'sm@_itunes_games_role_playing',
  itunes_games_simulation: 'sm@_itunes_games_simulation',
  itunes_games_sports: 'sm@_itunes_games_sports',
  itunes_games_strategy: 'sm@_itunes_games_strategy',
  itunes_games_trivia: 'sm@_itunes_games_trivia',
  itunes_games_word: 'sm@_itunes_games_word',
  itunes_health_and_fitness: 'sm@_itunes_health_and_fitness',
  itunes_lifestyle: 'sm@_itunes_lifestyle',
  itunes_magazines_newspapers: 'sm@_itunes_magazines_newspapers',
  itunes_medical: 'sm@_itunes_medical',
  itunes_music: 'sm@_itunes_music',
  itunes_navigation: 'sm@_itunes_navigation',
  itunes_news: 'sm@_itunes_news',
  itunes_newsstand: 'sm@_itunes_newsstand',
  itunes_photo_and_video: 'sm@_itunes_photo_and_video',
  itunes_productivity: 'sm@_itunes_productivity',
  itunes_reference: 'sm@_itunes_reference',
  itunes_shopping: 'sm@_itunes_shopping',
  itunes_social_networking: 'sm@_itunes_social_networking',
  itunes_sports: 'sm@_itunes_sports',
  itunes_stickers: 'sm@_itunes_stickers',
  itunes_travel: 'sm@_itunes_travel',
  itunes_utilities: 'sm@_itunes_utilities',
  itunes_weather: 'sm@_itunes_weather'
};



export const GPLAY_CATEGORY_MAP = {
  gplay_game_casual: 'sm@_gplay_game_casual',
  gplay_auto_and_vehicles: 'sm@_gplay_auto_and_vehicles',
  gplay_books_and_references: 'sm@_gplay_books_and_references',
  gplay_business: 'sm@_gplay_business',
  gplay_comics: 'sm@_gplay_comics',
  gplay_communication: 'sm@_gplay_communication',
  gplay_education: 'sm@_gplay_education',
  gplay_entertainment: 'sm@_gplay_entertainment',
  gplay_finance: 'sm@_gplay_finance',
  gplay_game_action: 'sm@_gplay_game_action',
  gplay_game_adventure: 'sm@_gplay_game_adventure',
  gplay_game_arcade: 'sm@_gplay_game_arcade',
  gplay_game_board: 'sm@_gplay_game_board',
  gplay_game_card: 'sm@_gplay_game_card',
  gplay_game_casino: 'sm@_gplay_game_casino',
  gplay_game_educational: 'sm@_gplay_game_educational',
  gplay_game_family: 'sm@_gplay_game_family',
  gplay_game_music: 'sm@_gplay_game_music',
  gplay_game_puzzle: 'sm@_gplay_game_puzzle',
  gplay_game_racing: 'sm@_gplay_game_racing',
  gplay_game_role_playing: 'sm@_gplay_game_role_playing',
  gplay_games: 'sm@_gplay_games',
  gplay_game_simulation: 'sm@_gplay_game_simulation',
  gplay_game_sports: 'sm@_gplay_game_sports',
  gplay_game_strategy: 'sm@_gplay_game_strategy',
  gplay_game_trivia: 'sm@_gplay_game_trivia',
  gplay_game_word: 'sm@_gplay_game_word',
  gplay_health_and_fitness: 'sm@_gplay_health_and_fitness',
  gplay_libraries_and_demo: 'sm@_gplay_libraries_and_demo',
  gplay_lifestyle: 'sm@_gplay_lifestyle',
  gplay_live_wallpaper: 'sm@_gplay_live_wallpaper',
  gplay_media_and_video: 'sm@_gplay_media_and_video',
  gplay_medical: 'sm@_gplay_medical',
  gplay_music_and_audio: 'sm@_gplay_music_and_audio',
  gplay_news_and_magazines: 'sm@_gplay_news_and_magazines',
  gplay_personalisation: 'sm@_gplay_personalisation',
  gplay_photography: 'sm@_gplay_photography',
  gplay_productivity: 'sm@_gplay_productivity',
  gplay_shopping: 'sm@_gplay_shopping',
  gplay_social: 'sm@_gplay_social',
  gplay_sports: 'sm@_gplay_sports',
  gplay_tools: 'sm@_gplay_tools',
  gplay_transportation: 'sm@_gplay_transportation',
  gplay_travel: 'sm@_gplay_travel',
  gplay_travel_and_local: 'sm@_gplay_travel_and_local',
  gplay_weather: 'sm@_gplay_weather',
  gplay_widgets: 'sm@_gplay_widgets',
  gplay_maps_and_navigation: 'sm@_gplay_maps_and_navigation',
  gplay_family_action: 'sm@_gplay_family_action',
  gplay_house_and_home: 'sm@_gplay_house_and_home',
  gplay_family_braingames: 'sm@_gplay_family_braingames',
  gplay_family: 'sm@_gplay_family',
  gplay_beauty: 'sm@_gplay_beauty',
  gplay_family_pretend: 'sm@_gplay_family_pretend',
  gplay_books_and_reference: 'sm@_gplay_books_and_reference',
  gplay_family_create: 'sm@_gplay_family_create',
  gplay_family_musicvideo: 'sm@_gplay_family_musicvideo',
  gplay_family_education: 'sm@_gplay_family_education',
  gplay_parenting: 'sm@_gplay_parenting',
  gplay_game: 'sm@_gplay_game',
  gplay_art_and_design: 'sm@_gplay_art_and_design',
  gplay_android_wear: 'sm@_gplay_android_wear',
  gplay_video_players: 'sm@_gplay_video_players',
  gplay_dating: 'sm@_gplay_dating',
  gplay_events: 'sm@_gplay_events',
  gplay_food_and_drink: 'sm@_gplay_food_and_drink'
};


export const mapSmCategory = (category) => {
  if (ITUNES_CATEGORY_MAP.hasOwnProperty(category)) {
    return ITUNES_CATEGORY_MAP[category];
  }

  if (GPLAY_CATEGORY_MAP.hasOwnProperty(category)) {
    return GPLAY_CATEGORY_MAP[category];
  }

  logErr(`has no translation for "${category}"`);

  return category;
};




// WEBPACK FOOTER //
// ./src/lib/categories.js